import { FormControl, FormGroup } from '@angular/forms';
import { ReportFilterDto } from '../../../../../../../types/dtos/reports.dto';
import { BaseSelectStep } from '../base-select-step';

export class SelectDeviceStep extends BaseSelectStep {

  public form: FormGroup = new FormGroup({
    selectType: new FormControl(),
    statusSelect: new FormControl(),
    modelSelect: new FormControl(),
    search: new FormControl(),
    ids: new FormControl()
  });

  getStepFilter(): ReportFilterDto {
    const {
      selectType,
      statusSelect,
      modelSelect,
      search,
      ids
    } = this.form.value;

    if (selectType == 'select') {
      return {
        ids: ids ?? undefined,
      };
    } else {
      return {
        filter: {
          status: statusSelect ?? undefined,
          search: search ?? undefined,
          model_id: modelSelect ? Number(modelSelect) : undefined,
        }
      };
    }
  }

  getForm(): FormGroup {
    return this.form;
  }
}
